import type { DeliveryMethodDto } from '@ordr-as/ordr-service-types/epos';
import { DeliveryMethodDtoType } from '@ordr-as/ordr-service-types/epos';
import { useLocation } from '../context/LocationContext';

const useDeliveryFee = (deliveryMethod: DeliveryMethodDto, tableNumber?: string) => {
  const { location } = useLocation();
  const tableDeliveryMethod = location.deliveryMethods.find((d) => d.type === DeliveryMethodDtoType.TABLE);

  if (tableNumber) {
    return tableDeliveryMethod?.feeAmount || 0;
  }

  return deliveryMethod?.feeAmount || 0;
};

export default useDeliveryFee;
